module.exports = __webpack_public_path__ + "static/media/freshbooks.8c413050.png";